<!-- 投诉建议 -->
<template>
    <div class="complaint-suggestion">
        <div class="guide-block"></div>
        <!-- 投诉建议类型 -->
        <div class="mine-function">
            <div class="mine-function-header flex align-center">
                <img class="mine-function-title-image" src="@/assets/images/suggestion/type.png" alt="" />
                <p class="mine-function-title">投诉分类</p>
            </div>
            <div class="mine-function-wrap">
                <div class="mine-function-item" v-for="(item, index) in dataList" :key="index" @click="handleItem(item)">
                    <div class="complaint-button" :class="query.type == item.type ? 'active-button' : ''">{{ item.complaintContent }}</div>
                </div>
            </div>
        </div>
        <div class="guide-block"></div>

        <!-- 问题建议 -->
        <div class="question-suggestion">
            <div class="question-suggestion-header flex align-center">
                <img class="question-suggestion-title-image" src="@/assets/images/suggestion/question.png" alt="" />
                <p class="question-suggestion-title">问题反馈</p>
            </div>
            <div class="question-suggestion-wrap">
                <van-field class="question-suggestion-textarea" v-model="query.complaintContent" rows="3" autosize type="textarea" maxlength="100" placeholder="请输入建议或反馈" />
            </div>

            <div class="question-suggestion-car">
                <div class="left">
                    <div>车辆信息</div>
                    <div class="small">（非必填）</div>
                </div>
                <div @click="showPicker" class="right">
                    <span v-if="query.plateNum">{{ query.plateNum }}</span>
                    <span v-else>请选择车牌</span>

                    <img src="@/assets/images/suggestion/right.png" alt="" />
                </div>
            </div>
            <!-- 图片上传 -->
            <div class="question-suggestion-upload">
                <uploader result-type="file" v-model="fileList" :max-count="2" :before-read="beforeRead" :after-read="clickUpload">
                    <div class="container">
                        <div class="container-center">
                            <div class="container-center-add">
                                <img src="@/assets/images/suggestion/add.png" alt="" />
                            </div>
                            <div>上传凭证</div>
                        </div>
                    </div>
                </uploader>
            </div>
        </div>

        <div class="complaint-suggestion-text">
            <p>1.涉及具体停车的反馈，请移步<span @click="skip">【订单申诉】点击进入</span></p>
            <p>2.涉及爱车其他投诉，请备注车牌号码，方便快速为您解决问题</p>
        </div>
        <!-- 提交申诉 -->
        <div class="guide-button">
            <van-button type="info" @click="submitAppeal" class="button">
                <template #default>
                    <div class="guide-item flex align-center">
                        <p style="color: #fff">提交申诉</p>
                    </div>
                </template>
            </van-button>
        </div>

        <popup v-model="showPop" position="bottom">
            <picker title="我的车牌" value-key="plateNum" show-toolbar :columns="carList" @confirm="onConfirm" @cancel="onCancel" @change="onChange" />
        </popup>
        <Dialog :show.sync="showDialog" @hideDialog="showDialog = false" @handleLeftBtn="hideDialog" @handleConfirm="handleConfirm" leftBtnText="查看详情" rightBtnText="确认" content="已成功提交投诉建议" />
    </div>
</template>

<script>
import { Popup, Picker, Uploader } from "vant";
import { listMyPlateNum, complaintAdvise, uploadImage } from "@/api/api";

import Dialog from "@/components/base/dialog/dialog.vue";
import { beforeRead } from "@/libs/tools";
export default {
    name: "complaintSuggestion",
    components: {
        Popup,
        Picker,
        Uploader,
        Dialog,
    },
    data() {
        return {
            showDialog: false,
            fileList: [], //图片上传列表
            carList: [
                {
                    plateNum: "不选择车牌",
                },
            ],
            showPop: false,
            query: {
                complaintContent: "", //投诉建议内容
                frontComplaintPic: "", //图片1
                plateNum: "", //车牌号
                postComplaintPic: "", //图片2
                type: 1,
            },

            dataList: [
                { complaintContent: "车牌认证", type: 1 },
                { complaintContent: "关于停车", type: 2 },
                { complaintContent: "关于充值", type: 3 },
                { complaintContent: "关于缴费", type: 4 },
                { complaintContent: "其他", type: 5 },
            ],
            code: "", //成功的单号
        };
    },

    computed: {},

    mounted() {
        this.getCarList();
    },

    methods: {
        beforeRead,
        skip() {
            this.$router.push({
                path: "/suggestion/orderAppeal",
            });
        },
        //上传文件
        clickUpload(file) {
            file.status = "uploading";
            file.message = "上传中...";

            uploadImage(file.file).then((res) => {
                if (res.code == 200) {
                    file.status = "done";
                    file.url = res.data.imgUrl;
                }
            });
        },
        hideDialog() {
            this.showDialog = false;
            this.$router.push({
                path: "/suggestion/orderAppeal/orderAppealDetail",
                query: { type: 2, id: this.code },
            });
        },
        handleConfirm() {
            this.showDialog = false;
            this.$router.push("/suggestion");
        },
        //查询绑定的车牌
        getCarList() {
            listMyPlateNum().then((res) => {
                if (res.code == 200) {
                    this.carList = [...this.carList, ...res.data];
                }
            });
        },
        //提交申诉
        submitAppeal() {
            let param = { ...this.query };
            if (!param.complaintContent) {
                this.$toast({
                    message: "请输入问题反馈",
                });
                return;
            }

            if (this.fileList.length < 2) {
                this.$toast({
                    message: "请上传两张图片",
                });
                return;
            } else if (this.fileList.length == 2) {
                param.frontComplaintPic = this.fileList[0].url;
                param.postComplaintPic = this.fileList[1].url;
            }
            complaintAdvise(param).then((res) => {
                if (res.code == 200) {
                    this.showDialog = true;
                    this.code = res.data;
                }
            });
        },
        showPicker() {
            this.showPop = true;
        },
        onChange() {},
        onCancel() {
            this.showPop = false;
        },

        onConfirm(e) {
            console.log(e);
            this.showPop = false;
            if (e.plateNum == "不选择车牌") {
                this.query.plateNum = "";
                return;
            }
            this.query.plateNum = e.plateNum;
        },
        handleItem(item) {
            this.query.type = item.type;
        },
    },
};
</script>
<style lang="less" scoped>
.complaint-suggestion {
    .complaint-button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 56px;
        width: 218px;
        border: 1px #d0d0d0 solid;
        border-radius: 15px;
    }
    .active-button {
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
        color: #fff;
        border: none;
    }
}

.complaint-suggestion-text {
    font-size: 24px;
    color: #666666;
    width: 100%;
    padding: 24px 32px;
    span {
        color: #009af3;
    }
}
.question-suggestion {
    width: 100%;
    height: 538px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;

    .question-suggestion-header {
        padding: 24px 32px;
        height: 96px;
        border-bottom: 1px #f5f8fa solid;
        .question-suggestion-title-image {
            width: 32px;
            height: 32px;
            margin-right: 16px;
        }
        .question-suggestion-title {
            color: #666666;
            font-size: 26px;
        }
    }
    .question-suggestion-wrap {
        padding: 24px 32px;
        height: 192px;
        .question-suggestion-textarea {
            color: #666666;
            background-color: #f5f5f5;
        }
    }
    .question-suggestion-car {
        height: 48px;
        margin: 24px 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
            display: flex;
            justify-content: center;
            align-items: center;
            .small {
                font-size: 20px;
            }
        }

        .right {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                display: inline-block;
                margin-left: 15px;
                width: 14px;
                height: 24px;
            }
        }
    }

    .question-suggestion-upload {
        height: 160px;
        padding: 0 32px;
        .container {
            height: 160px;
            width: 160px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #f5f5f5;
            color: #777777;
            .container-center {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .container-center-add {
                    margin: 10px 0;
                }
            }

            img {
                height: 44px;
                width: 44px;
            }
        }
    }
}

.guide-button {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    bottom: 0;
    height: 120px;
    width: 100%;
    background-color: #fff;

    .button {
        width: 90%;
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
        border-radius: 20px;
    }
}
.guide-block {
    height: 16px;
}

.mine-function {
    width: 100%;
    height: 256px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    .mine-function-header {
        padding: 24px 32px;
        .mine-function-title-image {
            width: 32px;
            height: 32px;
            margin-right: 16px;
        }
        .mine-function-title {
            color: #666666;
            font-size: 26px;
        }
    }
    .mine-function-wrap {
        display: flex;
        // justify-content: space-around;
        flex-wrap: wrap;
        .mine-function-item {
            width: 33%;
            display: flex;
            margin: 10px 0;
            justify-content: center;
            // flex-wrap: wrap;
            // align-content: flex-start;

            img {
                width: 80px;
                height: 80px;
                margin-bottom: 16px;
            }
            p {
                color: #999;
                font-size: 26px;
            }
        }
    }
}
</style>
